export const tablet ='@media(min-width:576px)'
export const desktop='@media(min-width:992px)'

 export const AccentColor='#355C7D'
 export const AccentColorTransparency='rgba(53,95,125,.75)'
 export const Raven="#373d3f"
 export const Ruby="#c02f1d"
 export const Lilia="#f2f3f4"

 export const CardBGColor='#373d3f'
 export const CardDropShadow='0 3px 4px black'

 export const InputFormColor='#6a859c'